module.exports = __webpack_public_path__ + "img/print-logo.2e6d1445.svg";